import styled from '@emotion/styled';
import classNames from 'classnames';
import React, { TableHTMLAttributes } from 'react';
import { buildCSSWithLength } from '../../styles';
import { Scroll } from '../table/types';

export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  /**
   * 테이블 스크롤 영역 너비/높이를 지정할 수 있습니다.
   *  - { x: number | string, y: number | string }
   *  - x: 가로 스크롤을 설정하고 스크롤 영역의 너비를 지정합니다.
   *  - y: 세로 스크롤을 설정하고 스크롤 영역의 높이를 지정합니다.
   *  - x 사용시 table-layout이 fixed 처리됩니다.(기본 auto)
   */
  scroll?: Scroll;
  /**
   * 테이블의 컬럼 리사이즈 활성화 여부
   *   - width값 지정된 컬럼은 resize가 불가합니다.
   *   - table-layout이 fixed 처리됩니다.(기본 auto)
   * @default false
   */
  resize?: boolean;
}

export const Table = React.forwardRef<HTMLTableElement, TableProps>(
  ({ children, className, scroll, resize, style, ...props }: TableProps, ref) => {
    return (
      <StyledTable
        ref={ref}
        className={classNames('pds-table', className)}
        scroll={scroll}
        resize={resize}
        style={style}
        {...props}
      >
        {children}
      </StyledTable>
    );
  },
);

const StyledTable = styled.table<{ scroll?: Scroll; resize?: boolean }>`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  ${({ scroll }) =>
    scroll?.x
      ? `
      table-layout: fixed;
      ${scroll?.x && `${buildCSSWithLength('min-width', scroll.x ?? '100%')}`};
    `
      : 'table-layout: auto;'}
  ${({ resize }) => resize && `table-layout: fixed;`}

  thead {
    > tr {
      > th {
        border-top: none;
        border-left: none;
        &:last-of-type:not(.show-right-border) {
          border-right: none;
        }
      }
    }
  }

  tbody {
    > tr {
      > th {
        border-top: none;
        border-left: none;
      }
      &:last-of-type {
        > th,
        > td {
          border-bottom: none;
        }
      }
    }
  }
`;
